var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import NoteForm from "./NoteForm";
import NoteService from "../../../Services/Note.service";
const NoteToOpportunityModal = (_a) => {
    var { opportunityId } = _a, modalProps = __rest(_a, ["opportunityId"]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { backdrop: "static", modalTitle: "New Note", handleSubmit: (state) => NoteService.saveForOpportunity({
            opportunityId,
            noteTypeIds: state.noteTypes.map((nt) => nt.id),
            text: state.text,
        }), children: (formProps) => _jsx(NoteForm, Object.assign({}, formProps)) })));
};
export default NoteToOpportunityModal;
